/* eslint no-use-before-define: 0 */ // -->
/* eslint-disable import/no-unused-modules */
import type { Car } from '~/types/generated-types';
import { useFormMetaDataStore } from '~/stores/formMetaData';
import { usePageContentStore } from '~/stores/pageContent';

export function useCar(loadByDefault: boolean = false) {
  const isReady = ref(false);

  const formStore = useFormMetaDataStore();
  const pageContent = usePageContentStore();
  const car = ref<Car | undefined>(undefined);
  const regNumber = ref('');

  const execute = async () => {
    if (loadByDefault) {
      loadCar();
    }
  };

  const setCar = (newCar: Car | undefined) => {
    if (newCar) {
      car.value = newCar;
      regNumber.value = car?.value?.generalInfo?.registrationNumber?.toUpperCase() ?? '';
      isReady.value = true;
    }
  };

  const carExistsInPageContent = pageContent.car !== undefined;

  if (carExistsInPageContent) {
    setCar(pageContent.car);
  }

  const loadCar = async () => {
    setCar(pageContent.car ?? undefined);
    isReady.value = true;
    setFormMetaData();
  };

  const setFormMetaData = () => {
    if (car?.value?.generalInfo?.brand && car.value.generalInfo.brand !== formStore.brand) {
      formStore.changeBrand(car.value.generalInfo.brand);
    }

    if (car.value?.generalInfo?.model && car.value.generalInfo.model !== formStore.model) {
      formStore.changeModel(car.value.generalInfo.model);
    }

    if (car?.value?.generalInfo?.registrationNumber && car?.value?.generalInfo.registrationNumber !== formStore.registrationNumber) {
      formStore.changeRegistrationNumber(car.value.generalInfo.registrationNumber);
    }
  };

  execute();

  return {
    car,
    isReady,
    regNumberUpperCase: regNumber,
    loadCar,
  };
}
